// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
// Turbolinks.start()
ActiveStorage.start()



// app/javascript/packs/application.js
// import consultationChannel from "../channels/consultation_channel";

// const messageForm = document.getElementById("new_message_form");
// const messageContent = document.getElementById("message_content");

// if (messageForm) {
//   messageForm.addEventListener("submit", function(e) {
//     e.preventDefault();
//     const content = messageContent.value;
//     consultationChannel.sendMessage(content);  // Відправка повідомлення через WebSocket
//     messageContent.value = "";  // Очищаємо поле вводу
//   });
// }
